webpackJsonp([4],{

/***/ 1024:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Tab; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }




var DEFAULT_CLASS = 'react-tabs__tab';

var Tab =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(Tab, _Component);

  function Tab() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = Tab.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.checkFocus();
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    this.checkFocus();
  };

  _proto.checkFocus = function checkFocus() {
    var _this$props = this.props,
        selected = _this$props.selected,
        focus = _this$props.focus;

    if (selected && focus) {
      this.node.focus();
    }
  };

  _proto.render = function render() {
    var _cx,
        _this = this;

    var _this$props2 = this.props,
        children = _this$props2.children,
        className = _this$props2.className,
        disabled = _this$props2.disabled,
        disabledClassName = _this$props2.disabledClassName,
        focus = _this$props2.focus,
        id = _this$props2.id,
        panelId = _this$props2.panelId,
        selected = _this$props2.selected,
        selectedClassName = _this$props2.selectedClassName,
        tabIndex = _this$props2.tabIndex,
        tabRef = _this$props2.tabRef,
        attributes = _objectWithoutPropertiesLoose(_this$props2, ["children", "className", "disabled", "disabledClassName", "focus", "id", "panelId", "selected", "selectedClassName", "tabIndex", "tabRef"]);

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li", _extends({}, attributes, {
      className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, (_cx = {}, _cx[selectedClassName] = selected, _cx[disabledClassName] = disabled, _cx)),
      ref: function ref(node) {
        _this.node = node;
        if (tabRef) tabRef(node);
      },
      role: "tab",
      id: id,
      "aria-selected": selected ? 'true' : 'false',
      "aria-disabled": disabled ? 'true' : 'false',
      "aria-controls": panelId,
      tabIndex: tabIndex || (selected ? '0' : null)
    }), children);
  };

  return Tab;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

Tab.defaultProps = {
  className: DEFAULT_CLASS,
  disabledClassName: DEFAULT_CLASS + "--disabled",
  focus: false,
  id: null,
  panelId: null,
  selected: false,
  selectedClassName: DEFAULT_CLASS + "--selected"
};

Tab.propTypes =  false ? {
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object, PropTypes.string]),
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object]),
  disabled: PropTypes.bool,
  tabIndex: PropTypes.string,
  disabledClassName: PropTypes.string,
  focus: PropTypes.bool,
  // private
  id: PropTypes.string,
  // private
  panelId: PropTypes.string,
  // private
  selected: PropTypes.bool,
  // private
  selectedClassName: PropTypes.string,
  tabRef: PropTypes.func // private

} : {};
Tab.tabsRole = 'Tab';

/***/ }),

/***/ 1025:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TabList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }





var TabList =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(TabList, _Component);

  function TabList() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = TabList.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className,
        attributes = _objectWithoutPropertiesLoose(_this$props, ["children", "className"]);

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("ul", _extends({}, attributes, {
      className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className),
      role: "tablist"
    }), children);
  };

  return TabList;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

TabList.defaultProps = {
  className: 'react-tabs__tab-list'
};

TabList.propTypes =  false ? {
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object])
} : {};
TabList.tabsRole = 'TabList';

/***/ }),

/***/ 1026:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TabPanel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }




var DEFAULT_CLASS = 'react-tabs__tab-panel';

var TabPanel =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(TabPanel, _Component);

  function TabPanel() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = TabPanel.prototype;

  _proto.render = function render() {
    var _cx;

    var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className,
        forceRender = _this$props.forceRender,
        id = _this$props.id,
        selected = _this$props.selected,
        selectedClassName = _this$props.selectedClassName,
        tabId = _this$props.tabId,
        attributes = _objectWithoutPropertiesLoose(_this$props, ["children", "className", "forceRender", "id", "selected", "selectedClassName", "tabId"]);

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", _extends({}, attributes, {
      className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, (_cx = {}, _cx[selectedClassName] = selected, _cx)),
      role: "tabpanel",
      id: id,
      "aria-labelledby": tabId
    }), forceRender || selected ? children : null);
  };

  return TabPanel;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

TabPanel.defaultProps = {
  className: DEFAULT_CLASS,
  forceRender: false,
  selectedClassName: DEFAULT_CLASS + "--selected"
};

TabPanel.propTypes =  false ? {
  children: PropTypes.node,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object]),
  forceRender: PropTypes.bool,
  id: PropTypes.string,
  // private
  selected: PropTypes.bool,
  // private
  selectedClassName: PropTypes.string,
  tabId: PropTypes.string // private

} : {};
TabPanel.tabsRole = 'TabPanel';

/***/ }),

/***/ 1027:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Tabs; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_propTypes__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__UncontrolledTabs__ = __webpack_require__(1028);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_count__ = __webpack_require__(406);
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }







var Tabs =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(Tabs, _Component);

  function Tabs(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _this.handleSelected = function (index, last, event) {
      var onSelect = _this.props.onSelect; // Call change event handler

      if (typeof onSelect === 'function') {
        // Check if the change event handler cancels the tab change
        if (onSelect(index, last, event) === false) return;
      }

      var state = {
        // Set focus if the change was triggered from the keyboard
        focus: event.type === 'keydown'
      };

      if (Tabs.inUncontrolledMode(_this.props)) {
        // Update selected index
        state.selectedIndex = index;
      }

      _this.setState(state);
    };

    _this.state = Tabs.copyPropsToState(_this.props, {}, props.defaultFocus);
    return _this;
  }

  var _proto = Tabs.prototype;

  _proto.componentWillReceiveProps = function componentWillReceiveProps(newProps) {
    if (false) {
      throw new Error("Switching between controlled mode (by using `selectedIndex`) and uncontrolled mode is not supported in `Tabs`.\nFor more information about controlled and uncontrolled mode of react-tabs see the README.");
    } // Use a transactional update to prevent race conditions
    // when reading the state in copyPropsToState
    // See https://github.com/reactjs/react-tabs/issues/51


    this.setState(function (state) {
      return Tabs.copyPropsToState(newProps, state);
    });
  };

  Tabs.inUncontrolledMode = function inUncontrolledMode(props) {
    return props.selectedIndex === null;
  };

  // preserve the existing selectedIndex from state.
  // If the state has not selectedIndex, default to the defaultIndex or 0
  Tabs.copyPropsToState = function copyPropsToState(props, state, focus) {
    if (focus === void 0) {
      focus = false;
    }

    var newState = {
      focus: focus
    };

    if (Tabs.inUncontrolledMode(props)) {
      var maxTabIndex = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__helpers_count__["a" /* getTabsCount */])(props.children) - 1;
      var selectedIndex = null;

      if (state.selectedIndex != null) {
        selectedIndex = Math.min(state.selectedIndex, maxTabIndex);
      } else {
        selectedIndex = props.defaultIndex || 0;
      }

      newState.selectedIndex = selectedIndex;
    }

    return newState;
  };

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        defaultIndex = _this$props.defaultIndex,
        defaultFocus = _this$props.defaultFocus,
        props = _objectWithoutPropertiesLoose(_this$props, ["children", "defaultIndex", "defaultFocus"]);

    var _this$state = this.state,
        focus = _this$state.focus,
        selectedIndex = _this$state.selectedIndex;
    props.focus = focus;
    props.onSelect = this.handleSelected;

    if (selectedIndex != null) {
      props.selectedIndex = selectedIndex;
    }

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__UncontrolledTabs__["a" /* default */], props, children);
  };

  return Tabs;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

Tabs.defaultProps = {
  defaultFocus: false,
  forceRenderTabPanel: false,
  selectedIndex: null,
  defaultIndex: null
};

Tabs.propTypes =  false ? {
  children: childrenPropType,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object]),
  defaultFocus: PropTypes.bool,
  defaultIndex: PropTypes.number,
  disabledTabClassName: PropTypes.string,
  domRef: PropTypes.func,
  forceRenderTabPanel: PropTypes.bool,
  onSelect: onSelectPropType,
  selectedIndex: selectedIndexPropType,
  selectedTabClassName: PropTypes.string,
  selectedTabPanelClassName: PropTypes.string
} : {};
Tabs.tabsRole = 'Tabs';

/***/ }),

/***/ 1028:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UncontrolledTabs; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_uuid__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_propTypes__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_count__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_childrenDeepMap__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_elementTypes__ = __webpack_require__(163);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }








 // Determine if a node from event.target is a Tab element

function isTabNode(node) {
  return 'getAttribute' in node && node.getAttribute('role') === 'tab';
} // Determine if a tab node is disabled


function isTabDisabled(node) {
  return node.getAttribute('aria-disabled') === 'true';
}

var canUseActiveElement;

try {
  canUseActiveElement = !!(typeof window !== 'undefined' && window.document && window.document.activeElement);
} catch (e) {
  // Work around for IE bug when accessing document.activeElement in an iframe
  // Refer to the following resources:
  // http://stackoverflow.com/a/10982960/369687
  // https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/12733599
  canUseActiveElement = false;
}

var UncontrolledTabs =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(UncontrolledTabs, _Component);

  function UncontrolledTabs() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.tabNodes = [];

    _this.handleKeyDown = function (e) {
      if (_this.isTabFromContainer(e.target)) {
        var index = _this.props.selectedIndex;
        var preventDefault = false;
        var useSelectedIndex = false;

        if (e.keyCode === 32 || e.keyCode === 13) {
          preventDefault = true;
          useSelectedIndex = false;

          _this.handleClick(e);
        }

        if (e.keyCode === 37 || e.keyCode === 38) {
          // Select next tab to the left
          index = _this.getPrevTab(index);
          preventDefault = true;
          useSelectedIndex = true;
        } else if (e.keyCode === 39 || e.keyCode === 40) {
          // Select next tab to the right
          index = _this.getNextTab(index);
          preventDefault = true;
          useSelectedIndex = true;
        } else if (e.keyCode === 35) {
          // Select last tab (End key)
          index = _this.getLastTab();
          preventDefault = true;
          useSelectedIndex = true;
        } else if (e.keyCode === 36) {
          // Select first tab (Home key)
          index = _this.getFirstTab();
          preventDefault = true;
          useSelectedIndex = true;
        } // This prevents scrollbars from moving around


        if (preventDefault) {
          e.preventDefault();
        } // Only use the selected index in the state if we're not using the tabbed index


        if (useSelectedIndex) {
          _this.setSelected(index, e);
        }
      }
    };

    _this.handleClick = function (e) {
      var node = e.target; // eslint-disable-next-line no-cond-assign

      do {
        if (_this.isTabFromContainer(node)) {
          if (isTabDisabled(node)) {
            return;
          }

          var index = [].slice.call(node.parentNode.children).filter(isTabNode).indexOf(node);

          _this.setSelected(index, e);

          return;
        }
      } while ((node = node.parentNode) !== null);
    };

    return _this;
  }

  var _proto = UncontrolledTabs.prototype;

  _proto.setSelected = function setSelected(index, event) {
    // Check index boundary
    if (index < 0 || index >= this.getTabsCount()) return;
    var _this$props = this.props,
        onSelect = _this$props.onSelect,
        selectedIndex = _this$props.selectedIndex; // Call change event handler

    onSelect(index, selectedIndex, event);
  };

  _proto.getNextTab = function getNextTab(index) {
    var count = this.getTabsCount(); // Look for non-disabled tab from index to the last tab on the right

    for (var i = index + 1; i < count; i++) {
      if (!isTabDisabled(this.getTab(i))) {
        return i;
      }
    } // If no tab found, continue searching from first on left to index


    for (var _i = 0; _i < index; _i++) {
      if (!isTabDisabled(this.getTab(_i))) {
        return _i;
      }
    } // No tabs are disabled, return index


    return index;
  };

  _proto.getPrevTab = function getPrevTab(index) {
    var i = index; // Look for non-disabled tab from index to first tab on the left

    while (i--) {
      if (!isTabDisabled(this.getTab(i))) {
        return i;
      }
    } // If no tab found, continue searching from last tab on right to index


    i = this.getTabsCount();

    while (i-- > index) {
      if (!isTabDisabled(this.getTab(i))) {
        return i;
      }
    } // No tabs are disabled, return index


    return index;
  };

  _proto.getFirstTab = function getFirstTab() {
    var count = this.getTabsCount(); // Look for non disabled tab from the first tab

    for (var i = 0; i < count; i++) {
      if (!isTabDisabled(this.getTab(i))) {
        return i;
      }
    }

    return null;
  };

  _proto.getLastTab = function getLastTab() {
    var i = this.getTabsCount(); // Look for non disabled tab from the last tab

    while (i--) {
      if (!isTabDisabled(this.getTab(i))) {
        return i;
      }
    }

    return null;
  };

  _proto.getTabsCount = function getTabsCount() {
    var children = this.props.children;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__helpers_count__["a" /* getTabsCount */])(children);
  };

  _proto.getPanelsCount = function getPanelsCount() {
    var children = this.props.children;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__helpers_count__["b" /* getPanelsCount */])(children);
  };

  _proto.getTab = function getTab(index) {
    return this.tabNodes["tabs-" + index];
  };

  _proto.getChildren = function getChildren() {
    var _this2 = this;

    var index = 0;
    var _this$props2 = this.props,
        children = _this$props2.children,
        disabledTabClassName = _this$props2.disabledTabClassName,
        focus = _this$props2.focus,
        forceRenderTabPanel = _this$props2.forceRenderTabPanel,
        selectedIndex = _this$props2.selectedIndex,
        selectedTabClassName = _this$props2.selectedTabClassName,
        selectedTabPanelClassName = _this$props2.selectedTabPanelClassName;
    this.tabIds = this.tabIds || [];
    this.panelIds = this.panelIds || [];
    var diff = this.tabIds.length - this.getTabsCount(); // Add ids if new tabs have been added
    // Don't bother removing ids, just keep them in case they are added again
    // This is more efficient, and keeps the uuid counter under control

    while (diff++ < 0) {
      this.tabIds.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers_uuid__["b" /* default */])());
      this.panelIds.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers_uuid__["b" /* default */])());
    } // Map children to dynamically setup refs


    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers_childrenDeepMap__["a" /* deepMap */])(children, function (child) {
      var result = child; // Clone TabList and Tab components to have refs

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__helpers_elementTypes__["a" /* isTabList */])(child)) {
        var listIndex = 0; // Figure out if the current focus in the DOM is set on a Tab
        // If it is we should keep the focus on the next selected tab

        var wasTabFocused = false;

        if (canUseActiveElement) {
          wasTabFocused = __WEBPACK_IMPORTED_MODULE_1_react___default.a.Children.toArray(child.props.children).filter(__WEBPACK_IMPORTED_MODULE_7__helpers_elementTypes__["b" /* isTab */]).some(function (tab, i) {
            return document.activeElement === _this2.getTab(i);
          });
        }

        result = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react__["cloneElement"])(child, {
          children: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers_childrenDeepMap__["a" /* deepMap */])(child.props.children, function (tab) {
            var key = "tabs-" + listIndex;
            var selected = selectedIndex === listIndex;
            var props = {
              tabRef: function tabRef(node) {
                _this2.tabNodes[key] = node;
              },
              id: _this2.tabIds[listIndex],
              panelId: _this2.panelIds[listIndex],
              selected: selected,
              focus: selected && (focus || wasTabFocused)
            };
            if (selectedTabClassName) props.selectedClassName = selectedTabClassName;
            if (disabledTabClassName) props.disabledClassName = disabledTabClassName;
            listIndex++;
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react__["cloneElement"])(tab, props);
          })
        });
      } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__helpers_elementTypes__["c" /* isTabPanel */])(child)) {
        var props = {
          id: _this2.panelIds[index],
          tabId: _this2.tabIds[index],
          selected: selectedIndex === index
        };
        if (forceRenderTabPanel) props.forceRender = forceRenderTabPanel;
        if (selectedTabPanelClassName) props.selectedClassName = selectedTabPanelClassName;
        index++;
        result = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react__["cloneElement"])(child, props);
      }

      return result;
    });
  };

  /**
   * Determine if a node from event.target is a Tab element for the current Tabs container.
   * If the clicked element is not a Tab, it returns false.
   * If it finds another Tabs container between the Tab and `this`, it returns false.
   */
  _proto.isTabFromContainer = function isTabFromContainer(node) {
    // return immediately if the clicked element is not a Tab.
    if (!isTabNode(node)) {
      return false;
    } // Check if the first occurrence of a Tabs container is `this` one.


    var nodeAncestor = node.parentElement;

    do {
      if (nodeAncestor === this.node) return true;
      if (nodeAncestor.getAttribute('data-tabs')) break;
      nodeAncestor = nodeAncestor.parentElement;
    } while (nodeAncestor);

    return false;
  };

  _proto.render = function render() {
    var _this3 = this;

    // Delete all known props, so they don't get added to DOM
    var _this$props3 = this.props,
        children = _this$props3.children,
        className = _this$props3.className,
        disabledTabClassName = _this$props3.disabledTabClassName,
        domRef = _this$props3.domRef,
        focus = _this$props3.focus,
        forceRenderTabPanel = _this$props3.forceRenderTabPanel,
        onSelect = _this$props3.onSelect,
        selectedIndex = _this$props3.selectedIndex,
        selectedTabClassName = _this$props3.selectedTabClassName,
        selectedTabPanelClassName = _this$props3.selectedTabPanelClassName,
        attributes = _objectWithoutPropertiesLoose(_this$props3, ["children", "className", "disabledTabClassName", "domRef", "focus", "forceRenderTabPanel", "onSelect", "selectedIndex", "selectedTabClassName", "selectedTabPanelClassName"]);

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", _extends({}, attributes, {
      className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className),
      onClick: this.handleClick,
      onKeyDown: this.handleKeyDown,
      ref: function ref(node) {
        _this3.node = node;
        if (domRef) domRef(node);
      },
      "data-tabs": true
    }), this.getChildren());
  };

  return UncontrolledTabs;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

UncontrolledTabs.defaultProps = {
  className: 'react-tabs',
  focus: false
};

UncontrolledTabs.propTypes =  false ? {
  children: childrenPropType,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object]),
  disabledTabClassName: PropTypes.string,
  domRef: PropTypes.func,
  focus: PropTypes.bool,
  forceRenderTabPanel: PropTypes.bool,
  onSelect: PropTypes.func.isRequired,
  selectedIndex: PropTypes.number.isRequired,
  selectedTabClassName: PropTypes.string,
  selectedTabPanelClassName: PropTypes.string
} : {};

/***/ }),

/***/ 1029:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Tabs__ = __webpack_require__(1027);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Tabs", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Tabs__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_TabList__ = __webpack_require__(1025);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TabList", function() { return __WEBPACK_IMPORTED_MODULE_1__components_TabList__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Tab__ = __webpack_require__(1024);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Tab", function() { return __WEBPACK_IMPORTED_MODULE_2__components_Tab__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_TabPanel__ = __webpack_require__(1026);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TabPanel", function() { return __WEBPACK_IMPORTED_MODULE_3__components_TabPanel__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_uuid__ = __webpack_require__(408);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "resetIdCounter", function() { return __WEBPACK_IMPORTED_MODULE_4__helpers_uuid__["a"]; });






/***/ }),

/***/ 122:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TotalView = function (_React$Component) {
  _inherits(TotalView, _React$Component);

  function TotalView() {
    _classCallCheck(this, TotalView);

    var _this = _possibleConstructorReturn(this, (TotalView.__proto__ || Object.getPrototypeOf(TotalView)).call(this));

    _this.handleNextClick = _this.handleOnClick.bind(_this, true);
    _this.handleBackClick = _this.handleOnClick.bind(_this, false);
    return _this;
  }

  _createClass(TotalView, [{
    key: 'handleOnClick',
    value: function handleOnClick(back) {
      document.querySelector('.react-tabs').scrollIntoView();
      if (back) {
        this.props.back();
      } else {
        this.props.next();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var nextButtonMargin = !this.props.back && this.props.next ? 'startup-calculator-btn-next-alone' : '';
      return _react2.default.createElement(
        'div',
        { className: 'startup-calculator-total-view' },
        _react2.default.createElement(
          'h2',
          null,
          this.props.title
        ),
        _react2.default.createElement(
          'div',
          { className: 'startup-calculator-total-value' },
          _react2.default.createElement(
            'span',
            null,
            '$'
          ),
          this.props.sum
        ),
        (this.props.back || this.props.next) && _react2.default.createElement(
          'div',
          { className: 'startup-calculator-btn-wrap' },
          this.props.back && _react2.default.createElement(
            'div',
            { className: 'startup-calculator-btn-back-wrap' },
            _react2.default.createElement(
              'p',
              null,
              'Back:'
            ),
            _react2.default.createElement(
              'button',
              {
                className: 'startup-calculator-btn-back',
                onClick: this.handleNextClick
              },
              this.props.backText
            )
          ),
          this.props.next && _react2.default.createElement(
            'div',
            { className: 'startup-calculator-btn-next-wrap ' + nextButtonMargin },
            _react2.default.createElement(
              'p',
              null,
              'Next:'
            ),
            _react2.default.createElement(
              'button',
              {
                className: 'startup-calculator-btn-next',
                onClick: this.handleBackClick
              },
              this.props.nextText
            )
          )
        )
      );
    }
  }]);

  return TotalView;
}(_react2.default.Component);

exports.default = TotalView;


TotalView.defaultProps = {
  back: null,
  next: null,
  backText: 'Back',
  nextText: 'Next'
};

TotalView.propTypes = {
  title: _propTypes2.default.string.isRequired,
  sum: _propTypes2.default.string.isRequired,
  back: _propTypes2.default.func,
  next: _propTypes2.default.func,
  backText: _propTypes2.default.string,
  nextText: _propTypes2.default.string
};

/***/ }),

/***/ 163:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = isTab;
/* harmony export (immutable) */ __webpack_exports__["c"] = isTabPanel;
/* harmony export (immutable) */ __webpack_exports__["a"] = isTabList;
function isTab(el) {
  return el.type && el.type.tabsRole === 'Tab';
}
function isTabPanel(el) {
  return el.type && el.type.tabsRole === 'TabPanel';
}
function isTabList(el) {
  return el.type && el.type.tabsRole === 'TabList';
}

/***/ }),

/***/ 235:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = deepMap;
/* harmony export (immutable) */ __webpack_exports__["b"] = deepForEach;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__elementTypes__ = __webpack_require__(163);
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




function isTabChild(child) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__elementTypes__["b" /* isTab */])(child) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__elementTypes__["a" /* isTabList */])(child) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__elementTypes__["c" /* isTabPanel */])(child);
}

function deepMap(children, callback) {
  return __WEBPACK_IMPORTED_MODULE_0_react__["Children"].map(children, function (child) {
    // null happens when conditionally rendering TabPanel/Tab
    // see https://github.com/reactjs/react-tabs/issues/37
    if (child === null) return null;

    if (isTabChild(child)) {
      return callback(child);
    }

    if (child.props && child.props.children && typeof child.props.children === 'object') {
      // Clone the child that has children and map them too
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"])(child, _objectSpread({}, child.props, {
        children: deepMap(child.props.children, callback)
      }));
    }

    return child;
  });
}
function deepForEach(children, callback) {
  return __WEBPACK_IMPORTED_MODULE_0_react__["Children"].forEach(children, function (child) {
    // null happens when conditionally rendering TabPanel/Tab
    // see https://github.com/reactjs/react-tabs/issues/37
    if (child === null) return;

    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__elementTypes__["b" /* isTab */])(child) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__elementTypes__["c" /* isTabPanel */])(child)) {
      callback(child);
    } else if (child.props && child.props.children && typeof child.props.children === 'object') {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__elementTypes__["a" /* isTabList */])(child)) callback(child);
      deepForEach(child.props.children, callback);
    }
  });
}

/***/ }),

/***/ 406:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getTabsCount;
/* harmony export (immutable) */ __webpack_exports__["b"] = getPanelsCount;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__childrenDeepMap__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__elementTypes__ = __webpack_require__(163);


function getTabsCount(children) {
  var tabCount = 0;
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__childrenDeepMap__["b" /* deepForEach */])(children, function (child) {
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__elementTypes__["b" /* isTab */])(child)) tabCount++;
  });
  return tabCount;
}
function getPanelsCount(children) {
  var panelCount = 0;
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__childrenDeepMap__["b" /* deepForEach */])(children, function (child) {
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__elementTypes__["c" /* isTabPanel */])(child)) panelCount++;
  });
  return panelCount;
}

/***/ }),

/***/ 407:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export childrenPropType */
/* unused harmony export onSelectPropType */
/* unused harmony export selectedIndexPropType */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__childrenDeepMap__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__elementTypes__ = __webpack_require__(163);


function childrenPropType(props, propName, componentName) {
  var error;
  var tabsCount = 0;
  var panelsCount = 0;
  var tabListFound = false;
  var listTabs = [];
  var children = props[propName];
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__childrenDeepMap__["b" /* deepForEach */])(children, function (child) {
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__elementTypes__["a" /* isTabList */])(child)) {
      if (child.props && child.props.children && typeof child.props.children === 'object') {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__childrenDeepMap__["b" /* deepForEach */])(child.props.children, function (listChild) {
          return listTabs.push(listChild);
        });
      }

      if (tabListFound) {
        error = new Error("Found multiple 'TabList' components inside 'Tabs'. Only one is allowed.");
      }

      tabListFound = true;
    }

    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__elementTypes__["b" /* isTab */])(child)) {
      if (!tabListFound || listTabs.indexOf(child) === -1) {
        error = new Error("Found a 'Tab' component outside of the 'TabList' component. 'Tab' components " + "have to be inside the 'TabList' component.");
      }

      tabsCount++;
    } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__elementTypes__["c" /* isTabPanel */])(child)) {
      panelsCount++;
    }
  });

  if (!error && tabsCount !== panelsCount) {
    error = new Error("There should be an equal number of 'Tab' and 'TabPanel' in `" + componentName + "`. " + ("Received " + tabsCount + " 'Tab' and " + panelsCount + " 'TabPanel'."));
  }

  return error;
}
function onSelectPropType(props, propName, componentName, location, propFullName) {
  var prop = props[propName];
  var name = propFullName || propName;
  var error = null;

  if (prop && typeof prop !== 'function') {
    error = new Error("Invalid " + location + " `" + name + "` of type `" + typeof prop + "` supplied " + ("to `" + componentName + "`, expected `function`."));
  } else if (props.selectedIndex != null && prop == null) {
    error = new Error("The " + location + " `" + name + "` is marked as required in `" + componentName + "`, but " + "its value is `undefined` or `null`.\n" + "`onSelect` is required when `selectedIndex` is also set. Not doing so will " + "make the tabs not do anything, as `selectedIndex` indicates that you want to " + "handle the selected tab yourself.\n" + "If you only want to set the inital tab replace `selectedIndex` with `defaultIndex`.");
  }

  return error;
}
function selectedIndexPropType(props, propName, componentName, location, propFullName) {
  var prop = props[propName];
  var name = propFullName || propName;
  var error = null;

  if (prop != null && typeof prop !== 'number') {
    error = new Error("Invalid " + location + " `" + name + "` of type `" + typeof prop + "` supplied to " + ("`" + componentName + "`, expected `number`."));
  } else if (props.defaultIndex != null && prop != null) {
    return new Error("The " + location + " `" + name + "` cannot be used together with `defaultIndex` " + ("in `" + componentName + "`.\n") + ("Either remove `" + name + "` to let `" + componentName + "` handle the selected ") + "tab internally or remove `defaultIndex` to handle it yourself.");
  }

  return error;
}

/***/ }),

/***/ 408:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = uuid;
/* harmony export (immutable) */ __webpack_exports__["a"] = reset;
// Get a universally unique identifier
var count = 0;
function uuid() {
  return "react-tabs-" + count++;
}
function reset() {
  count = 0;
}

/***/ }),

/***/ 451:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(20);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactTabs = __webpack_require__(1029);

var _Responsive = __webpack_require__(25);

var _ExpenseInputs = __webpack_require__(529);

var _ExpenseInputs2 = _interopRequireDefault(_ExpenseInputs);

var _AssetsInputs = __webpack_require__(527);

var _AssetsInputs2 = _interopRequireDefault(_AssetsInputs);

var _CostsInputs = __webpack_require__(528);

var _CostsInputs2 = _interopRequireDefault(_CostsInputs);

var _TotalView = __webpack_require__(122);

var _TotalView2 = _interopRequireDefault(_TotalView);

var _ResultsView = __webpack_require__(530);

var _ResultsView2 = _interopRequireDefault(_ResultsView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StartupCalculator = function (_React$Component) {
  _inherits(StartupCalculator, _React$Component);

  _createClass(StartupCalculator, null, [{
    key: 'init',
    value: function init(id, props) {
      _reactDom2.default.render(_react2.default.createElement(StartupCalculator, props), document.getElementById(id));
    }
  }, {
    key: 'formatCurrency',
    value: function formatCurrency(value) {
      return String(value).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
  }]);

  function StartupCalculator() {
    _classCallCheck(this, StartupCalculator);

    var _this = _possibleConstructorReturn(this, (StartupCalculator.__proto__ || Object.getPrototypeOf(StartupCalculator)).call(this));

    _this.state = {
      expenses: ['0', '0', '0', '0', '0', '0', '0'],
      assets: ['0', '0', '0', '0'],
      costs: ['0', '0', '0', '0', '0'],
      tabIndex: 0
    };
    _this.updateExpenses = _this.updateExpenses.bind(_this);
    _this.updateAssets = _this.updateAssets.bind(_this);
    _this.updateCosts = _this.updateCosts.bind(_this);
    _this.toExpensesTab = _this.setTabIndex.bind(_this, 0);
    _this.toAssetsTab = _this.setTabIndex.bind(_this, 1);
    _this.toCostsTab = _this.setTabIndex.bind(_this, 2);
    _this.toTotalTab = _this.setTabIndex.bind(_this, 3);
    return _this;
  }

  _createClass(StartupCalculator, [{
    key: 'setTabIndex',
    value: function setTabIndex(tabIndex) {
      this.setState({
        tabIndex: tabIndex
      });
    }
  }, {
    key: 'updateExpenses',
    value: function updateExpenses(value, index) {
      var expenses = this.state.expenses;

      expenses[index] = value;
      this.setState({
        expenses: expenses
      });
    }
  }, {
    key: 'updateAssets',
    value: function updateAssets(value, index) {
      var assets = this.state.assets;

      assets[index] = value;
      this.setState({
        assets: assets
      });
    }
  }, {
    key: 'updateCosts',
    value: function updateCosts(value, index) {
      var costs = this.state.costs;

      costs[index] = value;
      this.setState({
        costs: costs
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          costs = _state.costs,
          assets = _state.assets,
          expenses = _state.expenses;
      // toFixed converts to a string so we use urnary + to convert to number

      var costSum = +costs.reduce(function (a, b) {
        return parseFloat(a) + parseFloat(b);
      }, '0').toFixed(2);
      var assetSum = +assets.reduce(function (a, b) {
        return parseFloat(a) + parseFloat(b);
      }, '0').toFixed(2);
      var expenseSum = +expenses.reduce(function (a, b) {
        return parseFloat(a) + parseFloat(b);
      }, '0').toFixed(2);
      var total = +(costSum + assetSum + expenseSum).toFixed(2);
      total = StartupCalculator.formatCurrency(total);
      costSum = StartupCalculator.formatCurrency(costSum);
      assetSum = StartupCalculator.formatCurrency(assetSum);
      expenseSum = StartupCalculator.formatCurrency(expenseSum);

      return _react2.default.createElement(
        'div',
        { className: 'container startup-calculator-container' },
        _react2.default.createElement(
          'div',
          { className: 'row row-eq-height startup-calculator-equal-cols' },
          _react2.default.createElement(
            'div',
            { className: 'col-md-4 col-md-offset-1' },
            _react2.default.createElement(
              'h1',
              null,
              'Startup Costs Calculator'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-md-6' },
            _react2.default.createElement(
              'p',
              { className: 'startup-calculator-subtitle' },
              'We created a calculator that you can use to determine how much money you will need to keep your business running considering your initial costs before you begin to turn a profit. This total is based on the sum of your startup expenses, assets and recurring monthly costs.'
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'row row-eq-height startup-calculator-equal-cols' },
          _react2.default.createElement(
            'div',
            { className: 'col-xs-12 col-md-10 col-md-offset-1' },
            _react2.default.createElement(
              _reactTabs.Tabs,
              {
                selectedIndex: this.state.tabIndex,
                onSelect: function onSelect(tabIndex) {
                  return _this2.setState({ tabIndex: tabIndex });
                }
              },
              _react2.default.createElement(
                _reactTabs.TabList,
                null,
                _react2.default.createElement(
                  _reactTabs.Tab,
                  null,
                  'Expenses'
                ),
                _react2.default.createElement(
                  _reactTabs.Tab,
                  null,
                  'Assets'
                ),
                _react2.default.createElement(
                  _reactTabs.Tab,
                  null,
                  'Recurring Costs'
                ),
                _react2.default.createElement(
                  _Responsive.LargeMobile,
                  null,
                  _react2.default.createElement(
                    _reactTabs.Tab,
                    null,
                    'Total Costs'
                  )
                )
              ),
              _react2.default.createElement(
                _reactTabs.TabPanel,
                null,
                _react2.default.createElement(
                  'p',
                  { className: 'startup-calculator-pane-title' },
                  'Startup expenses are one time costs that occur before you open for business. These expenses are intangible.'
                ),
                _react2.default.createElement(_ExpenseInputs2.default, {
                  onChange: this.updateExpenses,
                  values: expenses,
                  sum: expenseSum,
                  next: this.toAssetsTab
                })
              ),
              _react2.default.createElement(
                _reactTabs.TabPanel,
                null,
                _react2.default.createElement(
                  'p',
                  { className: 'startup-calculator-pane-title' },
                  'Assets are tangible things or intangible expenses that you own (like intellectual property). Assets are not deductible like startup expenses.'
                ),
                _react2.default.createElement(_AssetsInputs2.default, {
                  onChange: this.updateAssets,
                  values: assets,
                  sum: assetSum,
                  back: this.toExpensesTab,
                  next: this.toCostsTab
                })
              ),
              _react2.default.createElement(
                _reactTabs.TabPanel,
                null,
                _react2.default.createElement(
                  'p',
                  { className: 'startup-calculator-pane-title' },
                  'The costs you pay to cover the monthly expenses associated with starting a business.'
                ),
                _react2.default.createElement(_CostsInputs2.default, {
                  onChange: this.updateCosts,
                  values: costs,
                  sum: costSum,
                  back: this.toAssetsTab,
                  next: this.toTotalTab
                })
              ),
              _react2.default.createElement(
                _Responsive.LargeMobile,
                null,
                _react2.default.createElement(
                  _reactTabs.TabPanel,
                  { className: 'startup-calculator-total-pane react-tabs__tab-panel' },
                  _react2.default.createElement(_TotalView2.default, {
                    title: 'Total Expenses',
                    sum: expenseSum
                  }),
                  _react2.default.createElement(_TotalView2.default, {
                    title: 'Total Assets',
                    sum: assetSum
                  }),
                  _react2.default.createElement(_TotalView2.default, {
                    title: 'Total Recurring Costs',
                    sum: costSum
                  }),
                  _react2.default.createElement(_TotalView2.default, {
                    title: 'Total',
                    sum: total
                  })
                )
              )
            )
          ),
          _react2.default.createElement(
            _Responsive.Desktop,
            null,
            _react2.default.createElement(_ResultsView2.default, {
              expenseSum: expenseSum,
              assetSum: assetSum,
              costSum: costSum,
              total: total
            })
          )
        )
      );
    }
  }]);

  return StartupCalculator;
}(_react2.default.Component);

exports.default = StartupCalculator;

/***/ }),

/***/ 470:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _StartupCalculator = __webpack_require__(451);

var _StartupCalculator2 = _interopRequireDefault(_StartupCalculator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

window.StartupCalculator = _StartupCalculator2.default;

/***/ }),

/***/ 527:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Responsive = __webpack_require__(25);

var _CalculatorInput = __webpack_require__(85);

var _CalculatorInput2 = _interopRequireDefault(_CalculatorInput);

var _TotalView = __webpack_require__(122);

var _TotalView2 = _interopRequireDefault(_TotalView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AssetsInputs = function AssetsInputs(props) {
  return _react2.default.createElement(
    _react2.default.Fragment,
    null,
    _react2.default.createElement(_CalculatorInput2.default, {
      title: 'Money in the bank',
      description: 'Additional cash in the bank on top of the money you will use to cover monthly expenses that can be used as a safety net or to cover expenses that might come up in the first few months of starting a business.',
      onChange: function onChange(e) {
        return props.onChange(e, 0);
      },
      value: props.values[0],
      className: 'startup-calculator-input-wrap',
      type: 'monetary'
    }),
    _react2.default.createElement(_CalculatorInput2.default, {
      title: 'Inventory',
      description: 'Inventory you have at the start of the business (doesn’t apply to service businesses).',
      onChange: function onChange(e) {
        return props.onChange(e, 1);
      },
      value: props.values[1],
      className: 'startup-calculator-input-wrap',
      type: 'monetary'
    }),
    _react2.default.createElement(_CalculatorInput2.default, {
      title: 'Equipment',
      description: 'Equipment you have before opening your doors (purchase price of land, office furniture, etc.).',
      onChange: function onChange(e) {
        return props.onChange(e, 2);
      },
      value: props.values[2],
      className: 'startup-calculator-input-wrap',
      type: 'monetary'
    }),
    _react2.default.createElement(_CalculatorInput2.default, {
      title: 'Other Assets',
      description: '',
      onChange: function onChange(e) {
        return props.onChange(e, 3);
      },
      value: props.values[3],
      className: 'startup-calculator-input-wrap startup-calculator-final-input',
      type: 'monetary'
    }),
    _react2.default.createElement(
      _Responsive.LargeMobile,
      null,
      _react2.default.createElement(_TotalView2.default, {
        title: 'Total Assets',
        sum: props.sum,
        back: props.back,
        next: props.next,
        backText: 'Expenses',
        nextText: 'Recurring Costs'
      })
    )
  );
};

AssetsInputs.defaultProps = {
  back: null,
  next: null
};

AssetsInputs.propTypes = {
  onChange: _propTypes2.default.func.isRequired,
  values: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
  sum: _propTypes2.default.string.isRequired,
  back: _propTypes2.default.func,
  next: _propTypes2.default.func
};

exports.default = AssetsInputs;

/***/ }),

/***/ 528:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Responsive = __webpack_require__(25);

var _CalculatorInput = __webpack_require__(85);

var _CalculatorInput2 = _interopRequireDefault(_CalculatorInput);

var _TotalView = __webpack_require__(122);

var _TotalView2 = _interopRequireDefault(_TotalView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CostsInputs = function CostsInputs(props) {
  return _react2.default.createElement(
    _react2.default.Fragment,
    null,
    _react2.default.createElement(_CalculatorInput2.default, {
      title: 'Rent and utilities',
      description: 'Expenses you pay for your home on a monthly basis (electric, lights, wifi, etc.).',
      onChange: function onChange(e) {
        return props.onChange(e, 0);
      },
      value: props.values[0],
      className: 'startup-calculator-input-wrap',
      type: 'monetary'
    }),
    _react2.default.createElement(_CalculatorInput2.default, {
      title: 'Payroll',
      description: 'What you pay your employees.',
      onChange: function onChange(e) {
        return props.onChange(e, 1);
      },
      value: props.values[1],
      className: 'startup-calculator-input-wrap',
      type: 'monetary'
    }),
    _react2.default.createElement(_CalculatorInput2.default, {
      title: 'Inventory and equipment',
      description: 'Supplies whose expenses carry through month to month (paper shipments, etc.).',
      onChange: function onChange(e) {
        return props.onChange(e, 2);
      },
      value: props.values[2],
      className: 'startup-calculator-input-wrap',
      type: 'monetary'
    }),
    _react2.default.createElement(_CalculatorInput2.default, {
      title: 'Marketing',
      description: 'Cost of ads, featuring the project in magazines, social media, etc.',
      onChange: function onChange(e) {
        return props.onChange(e, 3);
      },
      value: props.values[3],
      className: 'startup-calculator-input-wrap',
      type: 'monetary'
    }),
    _react2.default.createElement(_CalculatorInput2.default, {
      title: 'Other Costs',
      description: '',
      onChange: function onChange(e) {
        return props.onChange(e, 4);
      },
      value: props.values[4],
      className: 'startup-calculator-input-wrap startup-calculator-final-input',
      type: 'monetary'
    }),
    _react2.default.createElement(
      _Responsive.LargeMobile,
      null,
      _react2.default.createElement(_TotalView2.default, {
        title: 'Total Recurring Costs',
        sum: props.sum,
        back: props.back,
        next: props.next,
        backText: 'Assets',
        nextText: 'Total Costs'
      })
    )
  );
};

CostsInputs.defaultProps = {
  back: null,
  next: null
};

CostsInputs.propTypes = {
  onChange: _propTypes2.default.func.isRequired,
  values: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
  sum: _propTypes2.default.string.isRequired,
  back: _propTypes2.default.func,
  next: _propTypes2.default.func
};

exports.default = CostsInputs;

/***/ }),

/***/ 529:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Responsive = __webpack_require__(25);

var _CalculatorInput = __webpack_require__(85);

var _CalculatorInput2 = _interopRequireDefault(_CalculatorInput);

var _TotalView = __webpack_require__(122);

var _TotalView2 = _interopRequireDefault(_TotalView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ExpenseInputs = function ExpenseInputs(props) {
  return _react2.default.createElement(
    _react2.default.Fragment,
    null,
    _react2.default.createElement(_CalculatorInput2.default, {
      title: 'Legal',
      description: 'Money spent on legal fees related to establishing the business, registrations, licenses, trademarking, etc.',
      onChange: function onChange(e) {
        return props.onChange(e, 0);
      },
      value: props.values[0],
      className: 'startup-calculator-input-wrap',
      type: 'monetary'
    }),
    _react2.default.createElement(_CalculatorInput2.default, {
      title: 'Design',
      description: 'Money spent on design for the business including a professional logo and website design.',
      onChange: function onChange(e) {
        return props.onChange(e, 1);
      },
      value: props.values[1],
      className: 'startup-calculator-input-wrap',
      type: 'monetary'
    }),
    _react2.default.createElement(_CalculatorInput2.default, {
      title: 'Space',
      description: 'Expenses that occur related to the space your business will occupy. Insurance on your office and on inventory, security deposit and rent you pay before opening your doors.',
      onChange: function onChange(e) {
        return props.onChange(e, 2);
      },
      value: props.values[2],
      className: 'startup-calculator-input-wrap',
      type: 'monetary'
    }),
    _react2.default.createElement(_CalculatorInput2.default, {
      title: 'Equipment',
      description: 'Computer and office equipment (which are important startup costs as the IRS allows a certain amount of these costs to be deducted), software and other technology expenses.',
      onChange: function onChange(e) {
        return props.onChange(e, 3);
      },
      value: props.values[3],
      className: 'startup-calculator-input-wrap',
      type: 'monetary'
    }),
    _react2.default.createElement(_CalculatorInput2.default, {
      title: 'Employees',
      description: 'Cost of training employees, and pay for employees who are working before you are open for business (payroll).',
      onChange: function onChange(e) {
        return props.onChange(e, 4);
      },
      value: props.values[4],
      className: 'startup-calculator-input-wrap',
      type: 'monetary'
    }),
    _react2.default.createElement(_CalculatorInput2.default, {
      title: 'Marketing',
      description: 'Pre-launch marketing expenses including advertising expenses on social media channels, television, radio, print signs, etc.',
      onChange: function onChange(e) {
        return props.onChange(e, 5);
      },
      value: props.values[5],
      className: 'startup-calculator-input-wrap',
      type: 'monetary'
    }),
    _react2.default.createElement(_CalculatorInput2.default, {
      title: 'Other Costs',
      description: '',
      onChange: function onChange(e) {
        return props.onChange(e, 6);
      },
      value: props.values[6],
      className: 'startup-calculator-input-wrap startup-calculator-final-input',
      type: 'monetary'
    }),
    _react2.default.createElement(
      _Responsive.LargeMobile,
      null,
      _react2.default.createElement(_TotalView2.default, {
        title: 'Total Expenses',
        sum: props.sum,
        back: props.back,
        next: props.next,
        nextText: 'Assets'
      })
    )
  );
};

ExpenseInputs.defaultProps = {
  back: null,
  next: null
};

ExpenseInputs.propTypes = {
  onChange: _propTypes2.default.func.isRequired,
  values: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
  sum: _propTypes2.default.string.isRequired,
  back: _propTypes2.default.func,
  next: _propTypes2.default.func
};

exports.default = ExpenseInputs;

/***/ }),

/***/ 530:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ResultsView = function ResultsView(props) {
  return _react2.default.createElement(
    _react2.default.Fragment,
    null,
    _react2.default.createElement(
      'div',
      { className: 'col-sm-7 col-sm-offset-1 startup-calculator-results-labels-left' },
      _react2.default.createElement(
        'div',
        { className: 'startup-calculator-results' },
        _react2.default.createElement(
          'label',
          { htmlFor: 'expenseSum' },
          'Total Expenses'
        ),
        _react2.default.createElement(
          'label',
          { htmlFor: 'assetSum' },
          'Total Assets'
        ),
        _react2.default.createElement(
          'label',
          { htmlFor: 'costSum' },
          'Total Recurring Costs'
        )
      )
    ),
    _react2.default.createElement(
      'div',
      { className: 'col-sm-3 startup-calculator-results-labels-right' },
      _react2.default.createElement(
        'div',
        { className: 'startup-calculator-results' },
        _react2.default.createElement(
          'label',
          { htmlFor: 'total' },
          'Total'
        )
      )
    ),
    _react2.default.createElement(
      'div',
      { className: 'col-sm-7 col-sm-offset-1 startup-calculator-results-col-left' },
      _react2.default.createElement(
        'div',
        { className: 'startup-calculator-results' },
        _react2.default.createElement(ResultsViewOutput, {
          sum: props.expenseSum,
          id: 'expenseSum'
        }),
        _react2.default.createElement(ResultsViewOutput, {
          sum: props.assetSum,
          id: 'assetSum'
        }),
        _react2.default.createElement(ResultsViewOutput, {
          sum: props.costSum,
          id: 'costSum'
        })
      )
    ),
    _react2.default.createElement(
      'div',
      { className: 'col-sm-3 startup-calculator-results-col-right' },
      _react2.default.createElement(
        'div',
        { className: 'startup-calculator-results' },
        _react2.default.createElement(ResultsViewOutput, {
          sum: props.total,
          id: 'total'
        })
      )
    )
  );
};

var ResultsViewOutput = function ResultsViewOutput(props) {
  return _react2.default.createElement(
    'div',
    { className: 'startup-calculator-input' },
    _react2.default.createElement('input', {
      type: 'text',
      value: props.sum,
      id: props.id,
      disabled: true
    })
  );
};

ResultsViewOutput.propTypes = {
  id: _propTypes2.default.string.isRequired,
  sum: _propTypes2.default.string.isRequired
};

ResultsView.propTypes = {
  expenseSum: _propTypes2.default.string.isRequired,
  assetSum: _propTypes2.default.string.isRequired,
  costSum: _propTypes2.default.string.isRequired,
  total: _propTypes2.default.string.isRequired
};

exports.default = ResultsView;

/***/ })

},[470]);


// WEBPACK FOOTER //
// seo-startup-calculator.js